import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, Checkbox, CircularProgress } from 'material-ui';
import FlatButton from '../tc-ui/flat-button-with-loader';
import pluralize from 'pluralize';
import moment from 'moment';
import R from 'ramda';

const propTypes = {
  searchCompanyName: PropTypes.string,
  searchDomain: PropTypes.string,
  contractPeriod: PropTypes.object,
  open: PropTypes.bool,
  loadingData: PropTypes.bool,
  dataLoaded: PropTypes.bool,
  companyId: PropTypes.string,
  onRequestClose: PropTypes.func,
  requests: PropTypes.array,
  selectedIds: PropTypes.array,
  onCheck: PropTypes.func,
  discardSelected: PropTypes.func,
  onClickSelectAll: PropTypes.func,
  apiCallStatus: PropTypes.string,
};

const RequestsWithSameNameOrDomain = props => {
  const { open, onRequestClose, requests, selectedIds, onCheck, discardSelected, loadingData, dataLoaded, searchCompanyName, searchDomain, apiCallStatus, contractPeriod, onClickSelectAll } = props;
  const text = `requests sent to the same ${ searchDomain ? ` domain as ${searchDomain}` : ` company as ${searchCompanyName}` } for the selected contracting period - ${new Date(contractPeriod.startDate).getYear() - 100}-${new Date(contractPeriod.endDate).getYear() - 100}`;
  return (
    <Dialog
      open={open}
      onRequestClose={onRequestClose}
      actions={[
        <FlatButton label={apiCallStatus === 'success' ? 'Dismiss' : 'Cancel'} onTouchTap={onRequestClose} />,
        <FlatButton secondary label="Discard" onTouchTap={discardSelected} loader={apiCallStatus === 'processing'} disabled={R.isEmpty(selectedIds) || apiCallStatus === 'success'} />,
      ]}
    >
      {
        R.call(R.cond([
          [() => loadingData || apiCallStatus === 'processing', R.always(<CircularProgress style={{ margin: '20px 50% auto' }} />)],
          [() => dataLoaded && R.isEmpty(requests), R.always(<div style={{ margin: '20px' }}>
            {`We did not find any other ${text}`}
          </div>)],
          [() => apiCallStatus === 'success', R.always(<div style={{ margin: '20px' }}>{selectedIds.length} {pluralize('requests', selectedIds.length)} {pluralize('have', selectedIds.length)} been archived.</div>)],
          [() => apiCallStatus === 'error', R.always(<div style={{ margin: '20px' }}>There has been an error, please try again.</div>)],
          [R.T, R.always(
            <div>
              <div style={{ margin: '20px' }}>
                {`We found the following ${text}.  Please select which requests you would like to discard.`}
              </div>
              <Checkbox
                style={{ paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' }}
                label="Select All"
                checked={selectedIds.length === requests.length}
                onCheck={(_, checked) => onClickSelectAll(checked)}
              />
              {
                requests.map((contract, ix) => {
                  return (
                    <div key={ix} style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e0e0e0', padding: '8px 0' }}>
                      <Checkbox
                        style={{ width: '48px' }}
                        checked={R.contains(contract._id, selectedIds)}
                        onCheck={(_, checked) => onCheck(contract._id, checked)}
                      />
                      <div style={{ width: '70%' }}>
                        <div>{ contract.companyName }</div>
                        <small>{ contract.email }</small>
                      </div>
                      <small>last updated: {moment(contract.updatedAt).format('DD MMM YYYY')}</small>
                    </div>
                  );
                })
              }
            </div>
          )],
        ]))
      }
    </Dialog>
  );
};

RequestsWithSameNameOrDomain.propTypes = propTypes;

const mapStateToProps = ({ contracting }) => {
  return ({
    ...contracting.requestsWithSameNameOrDomainDialog,
  });
};

export default connect(mapStateToProps, {
  onRequestClose: () => ({ type: 'CLOSE_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME' }),
  onCheck: (id, checked) => ({ type: 'ON_CHECK_IN_REQUESTS_WITH_SAME_NAME_DIALOG', payload: { id, checked } }),
  discardSelected: () => ({ type: 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG' }),
  onClickSelectAll: (checked) => ({ type: 'ON_SELECT_ALL_IN_REQUESTS_WITH_SAME_NAME_DIALOG', payload: { checked } }),
})(RequestsWithSameNameOrDomain);



// WEBPACK FOOTER //
// ./src/app/components/contracting/requestsWithSameNameOrDomain.jsx